import React from 'react'

const DashboardEmployee = () => {
  return (
    <div>DashboardEmployee</div>
  )
}

export default DashboardEmployee